import React from "react";

export type Unpacked<T> = T extends (infer U)[] ? U : T;

export type TGlobal_Children = { children: React.ReactNode };

export enum FormSteps {
  OCCASION = "Occasion",
  ITEM_TYPES = "Item Types",
  // DESCRIPTION = "Description",
  // OPTIONAL = "Optional",
}
